enum StatusEnum {
  planned = '0',
  completed = '1',
}
export default StatusEnum;
